export default __webpack_public_path__ + "img/mastercard.4ad8ed0d.svg";